import React, { useState, useEffect, useMemo } from 'react'
import intl from 'react-intl-universal'
import { Skeleton, ErrorBlock, CapsuleTabs } from 'antd-mobile'
import { getMyCouponListModel } from '../../model/store'
import { getMemberInfo, getOwnStores } from '../../utils/storage/store'
import Header from '../../components/Header'
import CouponList from './CouponList'
import CouponIcon from '../../components/Icon/CouponIcon'
// const TABS = [
//     { key: '1', label: intl.get('available').d('Available'), value: 1 },
//     { key: '2', label: intl.get('used').d('Used'), value: 2 },
//     { key: '3', label: intl.get('expired').d('Expired'), value: 3 }
// ]
const Coupons = (props) => {
    const { callback, relateArea = '', getCouponCount ,from = '', storeId = ''} = props
    const [state, setState] = useState({
        couponState: '1',
        coupons: [],
        loading: false,
        tabs: [
            { key: '1', label: intl.get('available').d('Available'), value: 1 },
            { key: '2', label: intl.get('used').d('Used'), value: 2 },
            { key: '3', label: intl.get('expired').d('Expired'), value: 3 }
        ]
    })
    const { memberId } = getMemberInfo()

    const storeIds = useMemo(() => {
        const stores = getOwnStores() || []
        return from === 'transfer' ? [storeId] : stores.map(item => item.storeId)
    }, [from, storeId])
    
    useEffect(() => {
        setState(prev => ({
            ...prev,
            loading: true
        }))
        getMyCouponListModel({ memberId, couponState: state.couponState, storeIdList: storeIds.join() }, true).then(res => {
            const list = Object(res).hasOwnProperty('data') ? res.data : res
            setState(prev => ({
                ...prev,
                coupons: list || [],
                loading: false
            }))
        }).catch(err => {
            setState(prev => ({
                ...prev,
                coupons: [],
                loading: false
            }))
            console.log(err)
        })
    }, [memberId, storeIds, state.couponState])

    const nList = state.coupons?.filter(item => item.couponState === parseInt(state.couponState))

    return (
        <div className='coupons-wrapper'>
            <Header title={intl.get('od_coupon').d('优惠券')} callback={callback} />
            <div className='coupons-tabs'
                style={{
                    position: 'sticky',
                    top: 48,
                    zIndex: 999,
                    background: '#fff',
                }}>
                <CapsuleTabs
                    activeKey={state.couponState}
                    onChange={key => setState(prev => ({ ...prev, couponState: key }))}
                    style={{ '--active-title-color': '#fff' }}
                >
                    {state.tabs.map(tab => (
                        <CapsuleTabs.Tab title={tab.label} key={tab.value} />
                    ))}
                </CapsuleTabs>
            </div>
            {
                state.loading ? <div className='coupons-loading'>
                    <Skeleton.Title animated />
                    <Skeleton.Paragraph lineCount={3} animated />
                </div>
                    :
                    nList.length > 0 ?
                        <>
                            <CouponList
                                list={nList}
                                from='coupons'
                                couponState={state.couponState}
                                relateArea={relateArea}
                                getCouponCount={getCouponCount}
                                storeId={storeId}
                            />
                        </>

                        :
                        <div className='coupons-empty'>
                            <ErrorBlock status='empty' image={<CouponIcon width={40} height={40} color='#999' />} title='' description={intl.get('domNoData').d('暂无数据')} />
                        </div>
            }
        </div>
    )
}

export default Coupons
